import cn from 'classnames';
import styles from './hero.module.css';
import { container, item } from '../../../variants/animations';
import { motion } from 'framer-motion';
import VideoModal from '../../../components/VideoModal';
import { useState } from 'react';

const socials = [
  {
    icon: '/icons/twitter-x-fill.svg',
    href: 'https://x.com/mohammadix',
    label: 'Twitter',
  },
  {
    icon: '/icons/unsplash-line.svg',
    href: 'https://unsplash.com/@dotpro',
    label: 'Unsplash',
  },
  {
    icon: '/icons/dribbble-fill.svg',
    href: 'https://dribbble.com/erfan',
    label: 'Dribbble',
  },
  {
    icon: '/icons/instagram-line.svg',
    href: 'https://www.instagram.com/mohammadix/',
    label: 'Instagram',
  },
  {
    icon: '/icons/linkedin-fill.svg',
    href: '#',
    label: 'LinkedIn',
  },
];

export default function Hero() {
  const [modal, setModal] = useState(false);

  const closeModal = () => {
    setModal(false);
  };

  return (
    <motion.div variants={container} initial='hidden' animate='show'>
      <div className={cn('section', styles.section)}>
        <div className={cn('container', styles.container)}>
          <div className={styles.wrapper}>
            <div className={styles.social_wrapper}>
              {socials.map((social, index) => (
                <motion.a
                  variants={item}
                  key={index}
                  href={social.href}
                  target='_blank'
                  rel='noreferrer'
                  aria-label={social.label}
                  className={styles.social_icon}
                >
                  <img
                    src={social.icon}
                    alt={social.label}
                    width='24'
                    height='24'
                  />
                </motion.a>
              ))}
            </div>

            <motion.div variants={item}>
              <h1 className={cn('hero', styles.title)} variants={item}>
                Erfan Asadi
              </h1>
            </motion.div>
            <motion.div variants={item}>
              <p className={cn('body', styles.subtitle)}>
I am a Product Designer and erfan.pro is a design-driven digital product studio focused on building thoughtful, high-impact user experiences. We specialize in UI/UX design, SaaS platforms, mobile apps, and modern websites that combine clarity, strategy, and aesthetics.


              </p>
            </motion.div>
            <motion.div variants={item}>
              <a
                className={styles.email}
                href='mailto:i@erfan.pro'
              >
                i <span>[at]</span> erfan.pro
              </a>
            </motion.div>
          </div>
          <div className={styles.image_background}>
            <img className={styles.image} src='/myself.jpg' alt='Erfan Asadi' />

            
          </div>
          {modal ? (
            <section className={cn('background')}>
              <div className={cn('align')}>
                <VideoModal
                  embed='https://www.youtube.com/embed/KCONWLnm7FQ'
                  closeModal={closeModal}
                  setModal={setModal}
                />
              </div>
            </section>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
}
